<template>
    <section
        v-if="!showThirdNext"
        class="pop-form pop-sign-log login"
        :class="options.loginClass || ''"
    >
        <hgroup>
            <h2 v-if="loginTitle" v-html="loginTitle"></h2>
            <h3 v-if="loginSubTitle" v-html="loginSubTitle"></h3>
        </hgroup>
        <template v-if="showFacebook || showGoogle">
            <ThirdBox
                theme="classic"
                :enableFb="showFacebook"
                :enableGoogle="showGoogle"
                :fbBtnText="$t('common:fbBtnText')"
                :googleBtnText="$t('common:googleBtnText')"
                @auth="authCallback"
            >
            </ThirdBox>
            <p class="desc">
                <span>{{ $t('or') }}</span>
            </p>
        </template>
        <v-form
            :onSubmit="loginSubmit"
            :onSuccess="loginSubmitSuccess"
            :onError="loginSumbitError"
        >
            <v-input
                name="account"
                type="email"
                :placeholder="$t('common:emailAddress')"
                required
                focus
                clearable
                :value="options.defaultEmail"
            ></v-input>
            <v-input
                ref="password"
                class="pwd"
                name="password"
                :type="passwordType"
                :placeholder="$t('common:password')"
                required
                clearable
                :validateConfig="{
                    pattern: '^.{6,20}$',
                    'pattern-msg': $t('common:validate.passwordValidate')
                }"
            >
                <template #footer>
                    <a
                        v-if="!wordPressSSR"
                        class="forgot mg-color"
                        href="/forget-password"
                        rel="noopener noreferrer"
                    >{{ $t('common:login.loginForgot') }}</a
                    >
                </template>
            </v-input>
            <input type="submit" :value="$t('common:ok')" />
            <p v-show="loginErrorShow || thirdPartErrorShow" class="mg-error">
                {{ loginErrorMsg || thirdPartErrorMsg }}
            </p>
        </v-form>
        <p class="pop-footer create-account">
            {{ $t('common:login.newHere') }}
            <a
                @click.prevent="changeType('register')"
                rel="noopener noreferrer"
            >{{ $t('common:login.createAnAccount') }}</a
            >
        </p>
        <div
            v-if="footerHtml"
            class="pop-footer center"
            v-html="footerHtml"
        ></div>
    </section>
    <third-register-next
        ref="third-next"
        v-else
        :fullname="authData.firstName + ' ' + authData.lastName"
        :email="authData.email"
        :phoneRequired="!ignorPhone"
        :thirdPartErrorShow="thirdPartErrorShow"
        :thirdPartErrorMsg="thirdPartErrorMsg"
        :thirdRegisterSubmit="thirdRegisterSubmit"
        :thirdRegisterSubmitSuccess="thirdRegisterSubmitSuccess"
        :thirdRegisterSumbitError="thirdRegisterSumbitError"
    ></third-register-next>
</template>

<script>
import login from '../login.js';
import thirdPart from '../third-part.js';
import thirdRegisterNextVue from './third-register-next.vue';

export default {
    mixins: [login, thirdPart],
    components: {
        'third-register-next': thirdRegisterNextVue
    }
};
</script>
